import { Text } from "./TextConstants";
import CryptoJS from "crypto-js";
export const validateAddToCart = (products, date, slot) => {
  let error = {
    date: "",
    slot: "",
    products: "",
  };
  if (!date) {
    error.date = "Please select valid date";
  }
  // if (!slot) {
  //   error.slot = "Please select a valid slot";
  // }
  let filteredProducts = products?.filter((item) => item.count > 0);
  if (filteredProducts.length === 0) {
    error.products = "Please select atleast one product";
  }
  return error;
};

export const getFormattedDate = (d) => {
  const date = new Date(d);
  const yyyy = date.getFullYear();
  let mm = date.getMonth() + 1;
  let dd = date.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  const formattedDate = yyyy + "-" + mm + "-" + dd;
  return formattedDate;
};

export const getFormattedCart = (cart, itemsArray) => {
  let items = itemsArray.map((item) => {
    return {
      productId: item?.productId,
      date: item?.date,
      qty: item?.qty,
    };
  });
  return {
    cartId: cart?._id,
    items,
  };
};

export const Validation = (user, setError) => {
  if (user.email === "" && user.pin === "") {
    setError({
      email: Text.loginEnterEmail,
      pin: Text.loginEnterPassword,
    });
    return false;
  } else if (user.email === "") {
    setError({
      email: Text.loginEnterEmail,
      pin: "",
    });
    return false;
  } else if (user.pin === "") {
    setError({
      email: "",
      pin: Text.loginEnterPassword,
    });
    return false;
  } else if (!validateEmail(user.email)) {
    setError({
      email: Text.loginInvalidEmail,
      pin: "",
    });
    return false;
  } else {
    setError({
      email: "",
      pin: "",
    });
    return true;
  }
};

export const ValidationGuest = (user, setError) => {
  if (user.name === "" && user.email === "") {
    setError({
      name: Text.loginEntername,
      email: Text.loginEnterEmail,
    });
    return false;
  } else if (user.name === "") {
    setError({
      name: Text.loginEnterEmail,
      email: "",
    });
    return false;
  } else if (user.email === "") {
    setError({
      email: "",
      pin: Text.loginEnterPassword,
    });
    return false;
  } else if (!validateEmail(user.email)) {
    setError({
      name: "",
      email: Text.loginInvalidEmail,
    });
    return false;
  } else {
    setError({
      name: "",
      email: "",
    });
    return true;
  }
};

export const validationEmailConfirmation = (email, setConfirmEmailError) => {
  if (email === "") {
    setConfirmEmailError(Text.loginEnterEmail);
    return false;
  } else if (!validateEmail(email)) {
    setConfirmEmailError(Text.loginInvalidEmail);
    return false;
  } else {
    setConfirmEmailError("");
    return true;
  }
};

export const SignUpValidation = (user, setError) => {
  console.log("cap", user.captchaValue);
  if (
    user.email !== "" &&
    validateEmail(user.email) &&
    user.name !== "" &&
    user.mobileNo !== "" &&
    user.captchaValue !== ""
  ) {
    setError({
      email: "",
      name: "",
      mobileNo: "",
      captchaValue: "",
    });
    return true;
  } else {
    setError({
      email:
        user.email === ""
          ? Text.loginEnterEmail
          : !validateEmail(user.email)
          ? Text.loginInvalidEmail
          : "",
      name: user.name === "" ? Text.loginEntername : "",
      mobileNo: user.mobileNo === "" ? Text.loginEnterphone : "",
      captchaValue: user.captchaValue === "" ? Text.signUpEnterCaptcha : "",
    });
    console.log(user.mobileNo);
    return false;
  }
};

export const ForgotValidation = (user, setError) => {
  if (user.email === "") {
    setError({
      email: Text.loginEnterEmail,
    });
    return false;
  } else if (!validateEmail(user.email)) {
    setError({
      email: Text.loginInvalidEmail,
    });
    return false;
  } else {
    setError({
      email: "",
    });
    return true;
  }
};

export const validateEmail = (email) => {
  return !!String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const getRandomInteger = () => {
  return Math.floor(Math.random() * 1000000000000);
};

export const decryptSpinWheelId = async (cipherText) => {
  cipherText = decodeURIComponent(cipherText);
  let bytes = CryptoJS.AES.decrypt(
    cipherText,
    process.env.REACT_APP_SPIN_WHEEL_SECRET_KEY
  );
  let originalText = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(originalText);
};

export const isValidDate = (dateString) => {
  const date = new Date(dateString);
  return date instanceof Date && !isNaN(date);
};


export const checkIfGivenDateNotRestricted = (dates, bookingDate) => {
  return !dates?.includes(bookingDate);
};
